import { PresenceClient } from "@formant/core/client/PresenceClient";
import { duration } from "@formant/core/model/duration";
import { IIntervalQuery } from "@formant/core/model/IIntervalQuery";

import { IAuthStore } from "./IAuthStore";
import { IPresenceInterval } from "./IPresenceInterval";
import { PresenceCache } from "./PresenceCache";
import { StoreCache } from "./StoreCache";

export class PresenceStore {
    private queryCache = new StoreCache<IIntervalQuery, IPresenceInterval[]>({
        capacity: 1000,
        staleIntervalMs: 2 * duration.second,
    });
    private presenceCache!: PresenceCache;

    constructor(
        presenceClient: PresenceClient,
        private authStore: IAuthStore,
    ) {
        this.presenceCache = new PresenceCache(presenceClient);
    }

    public query(query: IIntervalQuery): IPresenceInterval[] | undefined {
        return this.queryCache.get(query, async () =>
            this.presenceCache.query(await this.authStore.token(), query),
        );
    }
}
